import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-badge',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="badge" [class.nabiz]="nabiz()" [style.background]="renk()">
      {{ gosterim() }}
    </span>
  `,
  styles: [`
    :host { display: inline-flex; }
    .badge {
      display: inline-flex; align-items: center; justify-content: center;
      min-width: 20px; height: 20px; padding: 0 6px;
      border-radius: 10px; font-size: 12px; font-weight: 700;
      color: #fff; line-height: 1;
    }
    .badge.nabiz { animation: pulse 1.4s ease-in-out infinite; }
    @keyframes pulse {
      0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 currentColor; }
      50% { transform: scale(1.1); box-shadow: 0 0 0 6px rgba(255,255,255,0); }
    }
  `],
})
export class BadgeComponent {
  sayi = input(0);
  renk = input('#f5222d');
  nabiz = input(false);

  gosterim = computed(() => this.sayi() > 99 ? '99+' : String(this.sayi()));
}
